module.exports = __webpack_public_path__ + "img/t4-m10.b9615461.png";